/*
 * Utility js functions to simplify lock table structure creation. (used by lock_table.jsp)
 *
 */
import $ from "jquery";
import messageResource from "./messageResource";
import OvertimeRow from "./locktable/rows/OvertimeRow";
import OtherTasksRow from "./locktable/rows/OtherTasksRow";
import UserGroupsSeparateRow from "./locktable/rows/UserGroupsSeparateRow";
import DisabledUsersSeparateRow from "./locktable/rows/DisabledUsersSeparateRow";
import InactiveRow from "./locktable/rows/InactiveRow";
import TaskRow from "./locktable/rows/TaskRow";
import LockTableDayInfo from "./locktable/model/LockTableDayInfo";

export function addHeaderCells( datesRow, runnerRow, date, isWorking, isRunnerOver, hasLockedInvisibleUser, hasUnlockedInvisibleUser )
{
    var dayInfo = new LockTableDayInfo( date, isWorking, isRunnerOver, hasLockedInvisibleUser, hasUnlockedInvisibleUser );
    datesRow.addCell( dayInfo );
    runnerRow.addCell( dayInfo );
}

export function buildUsersHeaderCell( lockTable, note, topMessage, sortByLink, showDetails)
{
    window.expandAllUserRows = function() {
        var userRows = lockTable.getUserRows();
        for( var i = 0; i < userRows.length; i++ )
        {
            var userRow = userRows[i];
            if( !userRow.isExpanded() )
                userRow.expand();
        }
    };
    window.collapseAllUserRows = function(){
        var userRows = lockTable.getUserRows();
        for( var i = 0; i < userRows.length; i++ )
        {
            var userRow = userRows[i];
            if( userRow.isExpanded() )
                userRow.collapse();
        }
    };

    var td = document.createElement("td");
    td.rowSpan = 3;
    td.className = "userTasksHeaderCell";
    var content = [ '<span class="sortByCaption">',topMessage,'</span>',
                    '<br/>',
                    '<div class="expandCollapseAllContainer">']

    if (showDetails){
        content.push('<a href="javascript:void(0);" onclick="expandAllUserRows()" class="expandCollapseAll noprint">',
                       messageResource.getMessage( "lock_tt.table.header.expand_all" ),
                       '</a>&nbsp;&nbsp;',
                       '<a href="javascript:void(0);" onclick="collapseAllUserRows()" class="expandCollapseAll noprint">',
                       messageResource.getMessage( "lock_tt.table.header.collapse_all" ),
                       '</a>');
    }

    content.push(sortByLink, '</div>');

    if( note )
    {
        content.push( '<div class="disabledUsersNote noteContainer">' );
        content.push(     '<img src="' );
        content.push(         note.imgPath );
        content.push(     '" class="noteImage"/>' );
        content.push(     '<span class="notemsg">' );
        content.push(         note.text );
        content.push(     '</span>' );
        content.push( '</div>' );
    }
    content.push( '<div class="rowHeaderWidthStrut"></div>' );

    td.innerHTML = content.join('');
    return td;
}

export function buildMonthRow( lockTable, monthArray, canGotoNextWeek, note, topMessage, sortByLink, showDetails)
{
    var row = document.createElement("tr");
    lockTable.getTBody().appendChild(row);

    //user group column
    var td = document.createElement("td");
    td.id = "userEmptyHeaderCell";
    td.rowSpan = 3;
    row.appendChild(td);

    row.appendChild( buildUsersHeaderCell( lockTable, note, topMessage, sortByLink, showDetails) );

    for( var i = 0; i < monthArray.length; i++ )
    {
        var month = monthArray[i];
        var lastMonthCell = ( i == ( monthArray.length - 1 ) );
        td = createMonthCell(month.description, month.datesInMonth, lastMonthCell);
        if( i == 0)
        {
            var div = document.createElement("div");
            div.className = 'gotoPrevWeekLinkContainer noprint';
            div.innerHTML = [ '<div class="gotoPrevWeekLinkPosition">',
                                  '<a class="scrollWeekLink" href="javascript:gotoPrevWeek();" title="',
                                           messageResource.getMessage("lock_tt.table.tooltip.7_days_back"),'">',
                                  '</a>',
                              '</div>' ].join("");
            td.appendChild( div );
        }

        if( canGotoNextWeek && lastMonthCell )
        {
            var div = document.createElement("div");
            div.className = 'gotoNextWeekLinkContainer noprint';
            div.innerHTML = [ '<div class="gotoNextWeekLinkPosition">',
                                  '<a class="scrollWeekLink" href="javascript:gotoNextWeek();" title="',
                                           messageResource.getMessage("lock_tt.table.tooltip.7_days_forward"),'">',
                                      '<div class="strut"></div>',
                                  '</a>',
                              '</div>' ].join("");
            td.appendChild( div );
        }

        if( lastMonthCell )
            td.className += " printTableRightBorder";

        row.appendChild(td);
    }
}

export function createMonthCell(value, colSpan, isLastMonthCell)
{
    var td = document.createElement("td");
    td.colSpan = colSpan;
    td.className = "monthCell " + (isLastMonthCell ? "lastMonthCell" : "");

    var div = document.createElement("div");
    var columnWidth = 48;
    div.className = "lockTableEllipsis";
    div.innerHTML = value;
    div.style.width = (columnWidth * colSpan - 10) + "px";
    td.appendChild( div );

    return td;
}

export function addUserRow( userGroup, table, userBean, values, approveValues, userWorkdayDurations, expandedUsersStorage, today )
{

    var userRow = userGroup.createUserRow( userBean.id, expandedUsersStorage, today, userWorkdayDurations );
    userRow.addCell( userBean );
    if( approveValues != null )
    {
        for( var i = 0; i < values.length; i++ )
        {
            values[i].approveInfo = approveValues[i];
        }
    }
    var hasData = false;
    for( var i = 0; i < values.length; i++ )
    {
        hasData |= values[i].actuals > 0;
        userRow.addCell( values[i] );
    }
    userRow.hasData = hasData;
    table.addRow( userRow );
    return userRow;
}

// function addLeaveTypeRow( targetRow, leaveInfo, values )
// {
//     var leaveTypeRow = new LeaveTypeRow();
//     leaveTypeRow.addCell( leaveInfo );
//     for( var i = 0; i < values.length; i++ )
//         leaveTypeRow.addCell( values[i] );
//     targetRow.addChildRow( leaveTypeRow );
//     targetRow.getTable().addRow( leaveTypeRow );
//     return leaveTypeRow;
// }

export function addLeaveTypeToUserRow ( targetRow, leaveInfo, values, headerText )
{
    var leaveTypeRow = targetRow.getUserLeavesRow();
    if(!leaveTypeRow)
        leaveTypeRow = targetRow.createUserLeavesRow(headerText);

    for( var i = 0; i < values.length; i++ )
        leaveTypeRow.addValueToCell( i + 1, {leaveInfo: leaveInfo, time: values[i]} );
}

export function addTaskRow(targetRow, taskBean, values)
{
    var taskRow = new TaskRow(taskBean.available ? (e) => {
        $(document).trigger("lockTT_table_taskClick", [e, taskBean.id])
    } : () => {});
    taskRow.addCell( taskBean );
    for( var i = 0; i < values.length; i++ )
    {
        taskRow.addCell( values[i] );
    }
    targetRow.addChildRow( taskRow );
    targetRow.getTable().addRow( taskRow );
    return taskRow;
}

export function addOvertimeRow( targetRow, headerText, values )
{
    var otRow = new OvertimeRow();
    otRow.addCell( headerText );
    for( var i = 0; i < values.length; i++ )
        otRow.addCell( values[i] );
    targetRow.addChildRow( otRow );
    targetRow.getTable().addRow( otRow );
    return otRow;
}

export function addOtherTasksRow(targetRow, headerText, values)
{
    var otherTasksRow = new OtherTasksRow();
    otherTasksRow.addCell(headerText);
    for (var i = 0; i < values.length; i++)
    {
        otherTasksRow.addCell(values[i]);
    }
    targetRow.addChildRow(otherTasksRow);
    targetRow.getTable().addRow(otherTasksRow);
    return otherTasksRow;
}

export function addSeparateRow( table, columnCount, isFirstRow, label )
{
    var separateRow;
    if (label === "")
    {
        separateRow = new DisabledUsersSeparateRow( isFirstRow );
        label = messageResource.getMessage("lock_tt.table.disabled_users_separator_text");
    }
    else
    {
        separateRow = new UserGroupsSeparateRow( isFirstRow );
    }
    separateRow.addCell( label );
    for( var i = 0; i < columnCount; i++ )
        separateRow.addCell( "&nbsp;" );
    table.addRow( separateRow );
    return separateRow;
}

export function addBottomBorderRow( table, columnCount )
{
    var inactiveRow = new InactiveRow();
    var rowHeader = 1;
    for( var i = 0; i < columnCount + rowHeader; i++ )
        inactiveRow.addCell( "&nbsp;" );
    table.addRow( inactiveRow );
    return inactiveRow;
}



// WEBPACK FOOTER //
// ./web/js/lock_table.js